$(document).ready(function() {
  $('.payment__cgv-input').on('change', function() {
    if ($(this).is(':checked')){
      $('.payment__choice-block').show();
    }
    else
    {
      $('.payment__choice-block').hide();
    }
  })

  $('.payment__cgv-input').each(function() {
    if ($(this).is(':checked')){
      $('.payment__choice-block').show();
    }
    else
    {
      $('.payment__choice-block').hide();
    }
  })

});
